import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { toast as showToast } from 'sonner'
import { type Toast } from '@/utils/toast.server.ts'

export function useToast(toast?: Toast | null) {
	const navigate = useNavigate()

	useEffect(() => {
		if (toast) {
			setTimeout(() => {
				showToast[toast.type](toast.title, {
					id: toast.id,
					description: toast.description,
					action: toast.link
						? {
								label: toast.link.label,
								onClick: () => navigate(toast.link!.href),
							}
						: undefined,
				})
			}, 0)
		}
	}, [toast, navigate])
}
